import { defineTokens } from '@chakra-ui/react/styled-system';

import object from './sizesAndSpacing.json';

const sizes = defineTokens.sizes({
  ...object,
  'layout/maxWidth/640': { value: '40rem' },
  'layout/maxWidth/960': { value: '60rem' },
  'layout/maxWidth/1280': { value: '80rem' },
  'layout/maxWidth/1616': { value: '101rem' },
});

export default sizes;
